import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import './Testimonials.css'

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

const Testimonials = () => {

    const clienttestimonials = [
        {
            name: 'Omkar Chaudhari',
            content: 'I’m very impressed with the support I received from Profcyma Finance Company.  They made the entire process simple, from explaining my options to helping me  choose the right financial plan. Thanks to them, I feel much more secure about my future.',
            image: '/assets/Image/icons/user.png'
        },
        {
            name: 'Abhishek shinde',
            content: 'I was nervous about managing my investments and planning for retirement, but PROFCYMA FINANCE COMPANY  made the process simple and stress-free. Their team listened to my goals, explained every step clearly, and provided a plan that actually works for me. I now feel more confident about my financial future, and I couldn’t be happier with their service.',
            image: '/assets/Image/icons/user.png'
        },
        {
            name: 'Shravani jorkar',
            content: 'I had a great experience with Profcyma Finance. Their customer service team was very professional, responsive, and guided me through every step of the process. They made everything simple and stress-free.',
            image: '/assets/Image/icons/user.png'
        },
        {
            name: 'Aditya jagtap',
            content: 'I’ve dealt with a few finance companies before, but Profcyma stands out for their honesty and transparency. They explained all terms clearly, with no hidden charges. I feel confident and secure with their services.',
            image: '/assets/Image/icons/user.png'
        },
        {
            name: 'Ankita terakar',
            content: 'I was impressed by how fast Profcyma Finance approved my application. Their interest rates are very competitive, and repayment options are flexible. A reliable company that really cares about customers.',
            image: '/assets/Image/icons/user.png'
        },
    ];

    return (
        <>
            <section className='testimonials_sec'>
                <div className='container'>
                    <p className='section_heading'>Client Testimonials</p>

                    <div className='slidersec'>
                        <Swiper
                            spaceBetween={30}
                            centeredSlides={false}
                            autoplay={{
                                delay: 2500,
                                disableOnInteraction: false,
                            }}
                            pagination={{
                                clickable: true,
                            }}
                            navigation={false}
                            modules={[Autoplay, Pagination, Navigation]}
                            className="mySwiper"
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,
                                    spaceBetween: 5,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                992: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                            }}
                        >
                            {clienttestimonials.map((data, index) => (
                                <SwiperSlide>
                                    <div className='slider_div'>
                                        <img className='quoteicon' src={process.env.PUBLIC_URL + '/assets/Image/icons/quote.png'} alt="quote-ocon" />
                                        <p className='testitext'>{data.content}</p>

                                        <div className='botdiv'>
                                            <img className='userimg' src={data.image} />
                                            <p className='name'>{data.name}</p>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Testimonials